module.exports = __webpack_public_path__ + "img/vivo.8c44a10f.jpg";